/* eslint-disable */

export const AverageKey = {
  NO_UNITS: 'noOfUnits',
  CAPITAL_GOODS: 'capitalGood',
  COST_EACH_UNITS: 'costOfEachUnit',
  SUPPLIER_DATA: 'supplierData',
  SUPPLIER_NAME: 'supplierId',
  POWER_CAPACITY: 'powerCapacity',
  STATUS: 'status',
  COMMENT: 'comment'
};

export const AverageLabel = {
  NO_UNITS: 'No. of Units',
  CAPITAL_GOODS: 'Capital Goods',
  COST_EACH_UNITS: 'Cost of each Unit',
  SUPPLIER_DATA: "Supplier's Data",
  SUPPLIER_NAME: 'Supplier Name',
  POWER_CAPACITY: 'Power Capacity',
  STATUS_COMMENTS: 'Status & Comments',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
